import React, {
  useCallback, useEffect, useState,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDropzone } from 'react-dropzone';
import JSZip from 'jszip';
import togeojson from '@mapbox/togeojson';
import CustomBtn from '../../../../generic/CustomBtn';
import { validateGeoJSONByRules } from '../../../../utils/helpers';

const shapefile = require('shapefile');

// 7b227479 (7b202274) - .geojson
// 3c3f786d - .kml
// 504b34 - .kmz
// 0027a - .shp
// const acceptType = ['7b227479', '3c3f786d', '504b34', '0027a'];

const GeoJsonUploader = ({
  setJsonFile,
  setShowMap,
  subZones,
  customClass,
  handleClickUpload,
}) => {
  const translate = useIntl();
  const [geoJson, setGeoJson] = useState([]);
  const [droppedFile, setDroppedFile] = useState([]);
  const [error, setError] = useState(0);
  const typesOfErrors = [{ id: 'wizardForm.step2.uploader.error1' },
    { id: 'wizardForm.step2.uploader.error2' },
    { id: 'wizardForm.step2.uploader.error3' },
    { id: 'wizardForm.step2.uploader.error4' }];
  // const checkAcceptTypes = (file) => {
  //   const fileReader = new FileReader();
  //   fileReader.readAsArrayBuffer(file);
  //
  //   fileReader.onload = (e) => {
  //     const arr = (new Uint8Array(e.target.result)).subarray(0, 4);
  //     let header = '';
  //     for (let i = 0; i < arr.length; i++) {
  //       header += arr[i].toString(16);
  //     }
  //     file.codeType = header;
  //     if (acceptType.includes(header)) {
  //       return null;
  //     }
  //     return {
  //       code: 'unsuitable file type',
  //       message: '.geojson, .kml, .kmz, .shp',
  //     };
  //   };
  // };
  const allowedExtensions = ['geojson', 'kml', 'kmz', 'shp'];

  const checkAcceptTypes = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      return {
        code: 'file-invalid-type',
        message: '.geojson, .kml, .kmz, .shp only',
      };
    }
    return null;
  };

  const getExtension = (fileName) => fileName.split('.').pop();

  const getDom = (xml) => (new DOMParser()).parseFromString(xml, 'text/xml');

  const getKmlDom = (kmzFile) => {
    const jsZip = new JSZip();
    return jsZip.loadAsync(kmzFile).then((zip) => {
      let kmlDom = null;
      zip.forEach((relPath, file) => {
        if (getExtension(relPath) === 'kml' && kmlDom === null) {
          kmlDom = file.async('string').then(getDom);
        }
      });
      // eslint-disable-next-line prefer-promise-reject-errors
      return kmlDom || Promise.reject('No kml file found');
    });
  };

  const hadnleGeoJsonFile = (data) => JSON.parse(data);

  const hadnleKMLFile = (data) => {
    const dom = new DOMParser().parseFromString(data, 'text/xml');
    const geo = togeojson.kml(dom);
    return geo;
  };

  const hadnleKMZFile = async (data) => {
    const kmlDom = await getKmlDom(data);
    const geo = togeojson.kml(kmlDom);
    return geo;
  };

  const handleSHPFile = async (data) => {
    const geoPromise = shapefile.open(data)
      .then((source) => source.read()
        .then((result) => {
          if (result.done) return;
          return result;
        }))
      // eslint-disable-next-line no-shadow
      .catch((error) => console.error(error.stack));

    const geo = await geoPromise;
    return geo;
  };

  // const onDrop = useCallback((inputFile) => {
  //   if (inputFile.length <= 0) {
  //     setError(4);
  //     return false;
  //   }
  //   setError(0);
  //
  //   const fileread = new FileReader();
  //   const filereadBuff = new FileReader();
  //   fileread.readAsText(inputFile[0]);
  //   filereadBuff.readAsArrayBuffer(inputFile[0]);
  //
  //   fileread.onload = async (e) => {
  //     const content = e.target.result;
  //     let geo;
  //     if (inputFile[0].codeType === '504b34') geo = await hadnleKMZFile(inputFile[0]);
  //     if (inputFile[0].codeType === '3c3f786d') geo = hadnleKMLFile(content);
  //     if (inputFile[0].codeType === '7b227479') geo = hadnleGeoJsonFile(content);
  //     if (geo) {
  //       const isNotValidation = validateGeoJSONByRules(geo);
  //       if (isNotValidation) {
  //         setError(isNotValidation);
  //       } else {
  //         const polygonData = geo?.features?.find((el) => el.geometry.type === 'Polygon');
  //         if (polygonData) {
  //           setDroppedFile([...inputFile]);
  //           setGeoJson([polygonData]);
  //         }
  //       }
  //     }
  //   };
  //
  //   filereadBuff.onload = async (e) => {
  //     const content = e.target.result;
  //     let geo;
  //     if (inputFile[0].codeType === '0027a') geo = await handleSHPFile(content);
  //     if (geo?.value) {
  //       const isNotValidation = validateGeoJSONByRules(geo.value);
  //       if (isNotValidation) {
  //         setError(isNotValidation);
  //       } else {
  //         const polygonData = geo?.value?.geometry.type === 'Polygon' && geo.value;
  //         if (polygonData) {
  //           setDroppedFile([...inputFile]);
  //           setGeoJson([polygonData]);
  //         }
  //       }
  //     }
  //   };
  // }, []);
  const onDrop = useCallback((inputFile) => {
    if (inputFile.length <= 0) {
      setError(4);
      return;
    }

    setError(0);
    const extension = inputFile[0].name.split('.').pop().toLowerCase();

    const fileReader = new FileReader();
    const fileReaderBuffer = new FileReader();

    fileReader.readAsText(inputFile[0]);
    fileReaderBuffer.readAsArrayBuffer(inputFile[0]);

    fileReader.onload = async (e) => {
      const content = e.target.result;
      let geo;

      if (extension === 'geojson') geo = hadnleGeoJsonFile(content);
      if (extension === 'kml') geo = hadnleKMLFile(content);
      if (extension === 'kmz') geo = await hadnleKMZFile(inputFile[0]);

      if (geo) {
        const isNotValidation = validateGeoJSONByRules(geo);
        if (isNotValidation) {
          setError(isNotValidation);
        } else {
          const polygonData = geo?.features?.find((el) => el.geometry.type === 'Polygon');
          if (polygonData) {
            setDroppedFile([...inputFile]);
            setGeoJson([polygonData]);
          }
        }
      }
    };

    fileReaderBuffer.onload = async (e) => {
      const content = e.target.result;
      if (extension === 'shp') {
        const geo = await handleSHPFile(content);
        if (geo?.value) {
          const isNotValidation = validateGeoJSONByRules(geo.value);
          if (isNotValidation) {
            setError(isNotValidation);
          } else {
            const polygonData = geo?.value?.geometry.type === 'Polygon' && geo.value;
            if (polygonData) {
              setDroppedFile([...inputFile]);
              setGeoJson([polygonData]);
            }
          }
        }
      }
    };
  }, []);

  useEffect(() => {
    if (geoJson.length > 0) {
      if (subZones) {
        handleClickUpload(geoJson);
      } else {
        const feature = geoJson[0];
        const featureId = feature.id || Date.now().toString();
        setJsonFile({
          features: [{
            ...feature,
            id: featureId,
            filename: droppedFile[0].path,
          }],
        });
      }
      setShowMap(true);
    }
  }, [geoJson]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    multiple: false,
    maxSize: 1e+7,
    validator: checkAcceptTypes,
    accept: [
      '.geojson',
      '.kml',
      '.kmz',
      '.shp',
    ],
  });
  return (
    <div className="wizard__geo-uploader">
      <div {...getRootProps()}>
        <div className="wizard__geo-wrapper">
          <input {...getInputProps()} />
          <CustomBtn
            label={translate.formatMessage({ id: 'button-uploadFile' })}
            handleClick={() => {}}
            customClass={`btn__map ${customClass}`}
          />
          {error ? <div className="wizard__types-file error">{translate.formatMessage(typesOfErrors[error - 1])}</div> : (
            <FormattedMessage
              id="wizardForm.step2.types"
              values={{
                div: (...chunks) => <div className="wizard__types-file ">{chunks}</div>,
                br: <br />,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default GeoJsonUploader;
